// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    GetCurrentAccount,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";

export const XngGetCurrentAccount: any = (props: any) => {
    const firstName = props.getState().accountNames.firstName;
    const lastName = props.getState().accountNames.lastName;

    let account = props.getState().pages.accountSettings.editingAccount;

    if (!account) {
        throw new Error("There was no current account when we are trying to save the current account");
    }

    account = { ...account, firstName, lastName };
    props.account = account;
};

replaceInChain(chain, GetCurrentAccount, XngGetCurrentAccount);
